import { QueryFunctionContext } from "@tanstack/react-query";
import client from "../client";
import appendQueryParams from "@/utils/appendQueryParams";

export function getPhotos(data: QueryFunctionContext) {
  return client.get(
    appendQueryParams(`/pexels/search`, data?.meta?.queryParams ?? {})
  );
}
